"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("./NoticeCancellation.module.css"));
var StudentAgreement_1 = require("./parts/StudentAgreement");
var SignatureAgreement_1 = require("./parts/SignatureAgreement");
function NoticeCancellation(props) {
    var isPdf = false;
    if (window.isPdf) {
        isPdf = true;
    }
    return (react_1.default.createElement("div", { className: styles.paddingTop },
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col-md-12 " + styles.textCenter },
                react_1.default.createElement("h4", null,
                    react_1.default.createElement("b", null, "Asher College")),
                react_1.default.createElement("h3", null,
                    react_1.default.createElement("b", null, "Notice of Cancellation")))),
        react_1.default.createElement(StudentAgreement_1.AsherStudentAgreement, null),
        react_1.default.createElement(SignatureAgreement_1.AsherSignatureAgreement, { nextForm: props.nextForm, nextStudentForm: props.nextStudentForm })));
}
exports.NoticeCancellation = NoticeCancellation;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTm90aWNlQ2FuY2VsbGF0aW9uLmNvbXBvbmVudC5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2Zvcm1zL2FzaGVyL05vdGljZUNhbmNlbGxhdGlvbi9Ob3RpY2VDYW5jZWxsYXRpb24uY29tcG9uZW50LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFBQSxnREFBeUI7QUFDekIsc0VBQXlEO0FBQ3pELDZEQUE4RDtBQUM5RCxpRUFBa0U7QUFFbEUsU0FBZ0Isa0JBQWtCLENBQUMsS0FBSztJQUNwQyxJQUFJLEtBQUssR0FBRyxLQUFLLENBQUE7SUFFakIsSUFBSSxNQUFNLENBQUMsS0FBSyxFQUFFO1FBQ2QsS0FBSyxHQUFHLElBQUksQ0FBQTtLQUNmO0lBRUQsT0FBTyxDQUNILHVDQUFLLFNBQVMsRUFBRSxNQUFNLENBQUMsVUFBVTtRQUM3Qix1Q0FBSyxTQUFTLEVBQUMsS0FBSztZQUNoQix1Q0FBSyxTQUFTLEVBQUUsZUFBYSxNQUFNLENBQUMsVUFBWTtnQkFDNUM7b0JBQ0kseURBQW9CLENBQ25CO2dCQUNMO29CQUNJLGtFQUE2QixDQUM1QixDQUNILENBQ0o7UUFDTiw4QkFBQyx3Q0FBcUIsT0FBRztRQUN6Qiw4QkFBQyw0Q0FBdUIsSUFDcEIsUUFBUSxFQUFFLEtBQUssQ0FBQyxRQUFRLEVBQ3hCLGVBQWUsRUFBRSxLQUFLLENBQUMsZUFBZSxHQUN4QyxDQUNBLENBQ1QsQ0FBQTtBQUNMLENBQUM7QUExQkQsZ0RBMEJDIn0=